import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchAll } from 'product_updates/ducks';
import ProductUpdates from 'product_updates/components';

const mapStateToProps = ({ productUpdates }) => {
  const { items, isFetching } = productUpdates;

  return {
    isFetching,
    items
  };
};

export default withRouter(connect(mapStateToProps, { fetchAll })(ProductUpdates));



// WEBPACK FOOTER //
// ./product_updates/containers/index.js